import axiosClient from '@/lib/axios';
import { Metadata } from '@/types';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import { VoteResultType } from '../types';

type VoteResultsResponse = {
  data: VoteResultType[];
  metadata: Metadata;
};

const getVoteResults = async ({
  companyID,
  meetingID,
  isByOwnership = false,
}: {
  companyID: number;
  meetingID?: number;
  isByOwnership?: boolean;
}): Promise<VoteResultsResponse> => {
  const { data } = await axiosClient.get<VoteResultsResponse>(
    `/companies/${companyID}/meetings/${meetingID}/meeting-points/results?limit=1000&isByOwnership=${isByOwnership}`,
  );
  return data;
};

type QueryFnType = typeof getVoteResults;

type UseGetVoteResultsOptions = {
  config?: QueryFunction<QueryFnType>;
  companyID: number;
  meetingID?: number;
  isByOwnership?: boolean;
};

export const useGetVoteResults = ({
  config,
  companyID,
  meetingID,
  isByOwnership = false,
}: UseGetVoteResultsOptions) => {
  return useQuery({
    queryKey: ['vote', 'results', companyID, meetingID, isByOwnership],
    queryFn: () => getVoteResults({ companyID, meetingID, isByOwnership }),
    ...config,
  });
};
